// extracted by mini-css-extract-plugin
module.exports = {"ZKComp":"ZK_ZKComp__0a773"};